import { Record } from 'immutable';

const RatePlanCodeRecord = Record({
  eventRatePlanCodeId: null,
  eventId: null,
  chain: null,
  brand: null,
  propertyId: null,
  ratePlanCode: null,
  createdDate: null,
  modifiedDate: null,
  createdBy: null,
  modifiedBy: null
});

export class RatePlanCode extends RatePlanCodeRecord {
  eventRatePlanCodeId: number;
  eventId: number;
  chain: string;
  brand: string;
  propertyId: number;
  ratePlanCode: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/rate-plan-code.ts